<div *ngIf="comments.length">
  <div class="row">
    <div class="col s12">
      <h3 class="h3 chart-title margin-none">
        {{ 'dashboard.comments' | translate }}
        <gl-tooltip posBottom [text]="tooltipText"></gl-tooltip>
      </h3>
    </div>
  </div>
  <div class="dashboard-carrousel">
    <div class="dashboard-carrousel-arrow" (click)="previous()">
      <i class="glicon-left-arrow"></i>
    </div>
    <div class="dashboard-container-text">
      <div
        class="dashboard-carrousel-text"
        *ngFor="let comment of comments; let i = index"
        [ngClass]="{ active: i === activeIndex }"
      >
        <span>{{ comment.comments }}</span>
        <div class="flex-center">
          <span class="subtext">{{ comment.userName }}</span>
          <span class="subtext">{{ comment.groupName }}</span>
          <span class="subtext">{{ comment.gameName }}</span>
          <span class="subtext">{{ comment.created_at | date }}</span>
        </div>
      </div>
    </div>
    <div class="dashboard-carrousel-arrow" (click)="next()">
      <i class="glicon-right-arrow"></i>
    </div>
  </div>
</div>
